var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { RoleList, userInformation } from '@src/app/helper';
import { useJob } from '@src/app/pages/JobPage/JobHooks/Job.hooks';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { FormatYearMonthDate } from '@src/app/helper';
import Datepicker from '@src/components/Atoms/Date/Date';
import DrawerComponent from '@src/components/Atoms/Drawer/Drawer';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useFormik } from 'formik';
import { useMemo } from 'react';
import * as Yup from 'yup';
export var ApprovalFormSchema = Yup.object().shape({
    paymentDue: Yup.string().required('Field belum diisi'),
});
export default function ApprovalActionKerjasama(_a) {
    var _this = this;
    var jobPubId = _a.jobPubId, job = _a.job;
    var role = JSON.parse(userInformation).roles[0];
    var _b = useState(false), isOpenApproval = _b[0], setOpenApproval = _b[1];
    var intl = useIntl();
    var ApprovalFormik = useFormik({
        initialValues: {
            paymentDue: dayjs().format('YYYY-MM-DD'),
        },
        enableReinitialize: true,
        validationSchema: ApprovalFormSchema,
        onSubmit: function (_a) {
            var paymentDue = _a.paymentDue;
            return __awaiter(_this, void 0, void 0, function () {
                var e_1, error;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, approveJob({ id: jobPubId, reason: null, paymentDue: paymentDue })];
                        case 1:
                            _b.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            e_1 = _b.sent();
                            error = e_1.response.data;
                            toast.error(error.message);
                            return [3 /*break*/, 4];
                        case 3:
                            setOpenApproval(false);
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
    });
    var _c = useJob(undefined, false), undoApprovalJob = _c.undoApprovalJob, approveJob = _c.approveJob;
    var handleUndoApproval = function () {
        swal({
            title: intl.formatMessage({ id: 'GENERAL.VALIDATION' }),
            text: '',
            icon: 'warning',
            buttons: [
                intl.formatMessage({ id: 'GENERAL.VALIDATION.NO' }),
                intl.formatMessage({ id: 'GENERAL.VALIDATION.YES' }),
            ],
            dangerMode: true,
        }).then(function (willUndo) { return __awaiter(_this, void 0, void 0, function () {
            var e_2, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!willUndo) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, undoApprovalJob(jobPubId)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        error = e_2.response.data;
                        toast.error(error.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    if (role !== RoleList.Audit)
        return null;
    var isApprovedLeader = job.isApprovedLeader, isCanceled = job.isCanceled, isCompleted = job.isCompleted, isDeal = job.isDeal, isHold = job.isHold;
    if (isDeal && !isApprovedLeader && !isCanceled && !isCompleted && !isHold) {
        return (_jsxs(_Fragment, { children: [isOpenApproval && (_jsx(ApprovalKerjasamaDrawerForm, { open: true, formik: ApprovalFormik, minDate: dayjs(), onClose: function () { return setOpenApproval(false); } })), _jsx("button", __assign({ className: 'btn btn-sm btn-primary', onClick: function () { return setOpenApproval(true); } }, { children: "Approve kerjasama" }))] }));
    }
    if (isApprovedLeader && !isCanceled && !isCompleted) {
        return (_jsx("button", __assign({ type: 'submit', className: 'btn btn-secondary btn-sm', onClick: function () { return handleUndoApproval(); } }, { children: "Undo Approval" })));
    }
    return null;
}
dayjs.extend(isSameOrAfter);
var ApprovalKerjasamaDrawerForm = function (_a) {
    var open = _a.open, formik = _a.formik, minDate = _a.minDate, onClose = _a.onClose;
    var handleChangeDate = function (e) {
        formik.setFieldValue('paymentDue', FormatYearMonthDate(e));
    };
    var isInputOK = useMemo(function () {
        return dayjs(formik.values.paymentDue).isSameOrAfter(dayjs(minDate), 'date');
    }, [formik.values, minDate]);
    return (_jsx(DrawerComponent, __assign({ open: open, handleClose: onClose, title: 'Konfirmasi Approval', size: 'MD' }, { children: _jsxs("form", __assign({ onSubmit: formik.handleSubmit }, { children: [_jsxs("div", { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder text-dark required', htmlFor: 'paymentDue' }, { children: "Due date" })), _jsx(Datepicker, { useForm: formik, date: formik.values.paymentDue, handleonchange: handleChangeDate }), _jsx("small", { children: "Due date tidak boleh kurang dari +13 hari sejak dibuat dari hari ini." })] }), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs("div", __assign({ className: 'd-flex gap-2 justify-content-end' }, { children: [_jsx("button", __assign({ type: 'button', className: 'btn btn-secondary btn-active-light-primary btn-sm', onClick: onClose }, { children: "Tutup" })), _jsx("button", __assign({ type: 'submit', className: 'btn btn-primary btn-sm ms-1', disabled: !isInputOK }, { children: "Simpan" }))] })) }))] })) })));
};
